// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".locales ul[data-v-48feacb4]{display:flex;align-items:center;flex-direction:column}.locales ul li[data-v-48feacb4]{text-decoration:none;list-style:none;padding-bottom:1em}.locales ul a[data-v-48feacb4]{font-size:18px;font-size:1.125rem;line-height:18px;line-height:1.125rem;color:hsla(0,0%,100%,.4);margin-top:20px;cursor:pointer;transition:all .2s ease-in-out;text-decoration:none}.locales ul a[data-v-48feacb4]:hover{color:#fff;font-weight:700;font-style:italic;position:relative}", ""]);
// Exports
module.exports = exports;
